import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Camera, Users, Star } from 'lucide-react';

interface EmptyPhotosPlaceholderProps {
  onAddPhotos: () => void;
  isHighlighted?: boolean;
}

export const EmptyPhotosPlaceholder: React.FC<EmptyPhotosPlaceholderProps> = ({ 
  onAddPhotos, 
  isHighlighted = false 
}) => {
  return (
    <Card 
      className={`bg-white/5 border-white/10 transition-all duration-300 ${
        isHighlighted ? 'ring-2 ring-luxury-gold animate-shake' : ''
      }`}
    >
      <CardContent className="p-6 text-center space-y-4">
        {/* Ícone */}
        <div className="mx-auto w-16 h-16 bg-luxury-gold/20 rounded-full flex items-center justify-center">
          <Camera className="h-8 w-8 text-luxury-gold" />
        </div>
        
        {/* Título */}
        <h3 className="text-lg font-semibold text-white">
          Adicione suas fotos
        </h3>
        
        {/* Descrição */}
        <p className="text-sm text-white/70">
          Perfis com fotos recebem muito mais interações na plataforma
        </p>
        
        {/* Benefícios (reutilizando do SkipPhotosDialog) */}
        <div className="space-y-2 text-left">
          <div className="flex items-center gap-3 p-3 bg-white/5 rounded-lg border border-white/10">
            <Users className="h-5 w-5 text-green-400" />
            <p className="text-sm text-gray-200">3x mais visualizações</p>
          </div>
          <div className="flex items-center gap-3 p-3 bg-white/5 rounded-lg border border-white/10">
            <Star className="h-5 w-5 text-yellow-400" />
            <p className="text-sm text-gray-200">Maior credibilidade</p>
          </div>
          <div className="flex items-center gap-3 p-3 bg-white/5 rounded-lg border border-white/10">
            <Camera className="h-5 w-5 text-blue-400" />
            <p className="text-sm text-gray-200">Perfis completos aparecem primeiro</p>
          </div>
        </div>
        
        {/* Botão de adicionar fotos */}
        <Button 
          onClick={onAddPhotos} 
          className="w-full bg-luxury-red hover:bg-luxury-red/90"
        >
          <Camera className="h-4 w-4 mr-2" />
          Adicionar Fotos
        </Button>
      </CardContent>
    </Card>
  );
};
